/**
 * Converts only number-like strings: "true" | "false"
 * @param value
 */
export function convertBooleanStringToBoolean(
    value: 'true' | 'false' | undefined,
): boolean {
    if (typeof value === 'string') {
        return value === 'true';
    }

    return !!value;
}
